import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-fab',
  templateUrl: './button-fab.component.html',
})
export class ButtonFabComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
